// extracted by mini-css-extract-plugin
export default {"ToC":"ToC_ToC__La2Go","Highlight":"ToC_Highlight__lA0fk"};